class Formulaire
{
    constructor()
    {
        this.current_gallery = [];
        this.lang = "fr";
        this.init();
    }

    init()
	{
        this.lang = document.querySelector('html').getAttribute('lang');

        if(document.querySelector(".form-devenir-membre")) {
        
            let links = document.querySelectorAll("a[href='#devenir-membre']");
            links.forEach(link =>
            {
                link.addEventListener("click", (e) =>
                {
                    e.preventDefault();
                    document.querySelector(".form-devenir-membre .form-response p").innerHTML = "";
                    gsap.to(".form-devenir-membre", {duration:0.5, display:"block", x:0, ease:"power3.out"});
                });
            });

			document.addEventListener("click", (e) =>
			{
                if(!e.target.closest("a[href='#devenir-membre']") && !e.target.closest(".form-devenir-membre")) {
					let newX = document.querySelector(".form-devenir-membre").offsetWidth + 40;
					gsap.to(".form-devenir-membre", {duration:0.5, display:"none", x:newX, ease:"power3.out"});
				}
			});
		}

        // Le formulaire de demande de lien d'édition sur la fiche d'un membre
        if(document.querySelector("#edit-fiche")) {

			document.querySelector("#edit-fiche").addEventListener("click", (e) =>
			{
				e.preventDefault();
				gsap.to(".form-update", {duration:0.5, display:"block", x:0, ease:"power3.out"});
				
			});

			document.addEventListener("click", (e) =>
			{
				if(!e.target.closest("#edit-fiche") && !e.target.closest(".form-update")) {
					let newX = document.querySelector(".form-update").offsetWidth + 40;
					gsap.to(".form-update", {duration:0.5, display:"none", x:newX, ease:"power3.out"});
				}
			});
		}

        // Indiquer le nom de l'image ou la quantité d'images sélectionnées
        var inputs = document.querySelectorAll('input[type=file]');
        Array.prototype.forEach.call(inputs, function(input)
        {
            let label = input.nextElementSibling;
            let labelVal = label.innerHTML;;

            input.addEventListener('change', function(e)
            {     
            
                if(this.files.length == 0)  {
                    label.querySelector('span').innerHTML = "";
                }

                const maxSizeInBytes = 4 * 1024 * 1024; // 2 Mo        
                var fileName = '';
                if(this.files && this.files.length > 1) {

                    let filesOk = 0;
                   
                    for(var i = 0; i < this.files.length; i++) {
                        
                        if (this.files[i].size <= maxSizeInBytes) {
                            filesOk++;
                        }
                    }

                    fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', filesOk);
                } else {
                    if(this.files[0]) {
                        if(this.files[0].size <= maxSizeInBytes) { 
                            fileName = e.target.value.split('\\').pop();
                        }
                    }
                }

                if(fileName) {
                    label.querySelector('span').innerHTML = fileName;
                } else {
                    label.innerHTML = labelVal;
                }
            });

        });
    
        // Changer l'ordre des jeux dans le formulaire des membres
        var jeuxContainer = document.querySelector('.jeux-container');
        if(jeuxContainer) {
            var sortableJeux = new Sortable(jeuxContainer, {
                animation: 150,
                ghostClass: 'ghost-class',
                onEnd: function (evt) {
                    let items = evt.from.children;
                    let newOrder = [];
                    for (var i = 0; i < items.length; i++) {
                        //newOrder.push(items[i].querySelector('img').dataset.id);
                    }
                    //document.querySelector('#updated_gallery').value = newOrder.join(',');
                }
            });
        }

        // Changer l'ordre des images de la galerie du formulaire des jeux
        var el = document.getElementById('galerie-preview');
        if(el) {
            var sortable = new Sortable(el, {
                animation: 150,
                ghostClass: 'ghost-class',
                onEnd: function (evt) {
                    let items = evt.from.children;
                    let newOrder = [];
                    for (var i = 0; i < items.length; i++) {
                        newOrder.push(items[i].querySelector('img').dataset.id);
                    }
                    document.querySelector('#updated_gallery').value = newOrder.join(',');
                }
            });
        }

        
        // Image d'un membre et image d'un jeu
        if(document.querySelector('form #image')) {
            document.getElementById('image').addEventListener('change', function (event)
            {
                const imagePreview = document.getElementById('image-preview');
                imagePreview.innerHTML = '';
                const file = event.target.files[0];
                if(file) {

                    const maxSizeInBytes = 4 * 1024 * 1024; // 2 Mo
                    if (file.size > maxSizeInBytes) {
                        event.preventDefault();

                        if(document.querySelector('html').getAttribute('lang') == "fr-FR") {
                            alert("Le fichier dépasse la taille maximale de 4 Mo. Veuillez sélectionner un fichier plus léger.");
                        } else {
                            alert("The file exceeds the maximum size of 4 MB. Please select a lighter file.");
                        }
                        return;
                    }

                    const reader = new FileReader();
                    reader.onload = function (e) {
                        const img = document.createElement('img');
                        img.src = e.target.result;
                        imagePreview.appendChild(img);
                    };
                    reader.readAsDataURL(file);
                }
            });
        }

        // Logo d'un membre
        if(document.getElementById('logo')) {
            document.getElementById('logo').addEventListener('change', function (event)
            {
                const imagePreview = document.getElementById('logo-preview');
                imagePreview.innerHTML = '';
                const file = event.target.files[0];
                if(file) {

                    const maxSizeInBytes = 4 * 1024 * 1024; // 2 Mo
                    if (file.size > maxSizeInBytes) {
                        event.preventDefault();
                        if(document.querySelector('html').getAttribute('lang') == "fr-FR") {
                            alert("Le fichier dépasse la taille maximale de 4 Mo. Veuillez sélectionner un fichier plus léger.");
                        } else {
                            alert("The file exceeds the maximum size of 4 MB. Please select a lighter file.");
                        }
                        return;
                    }

                    const reader = new FileReader();
                    reader.onload = function (e) {
                        const img = document.createElement('img');
                        img.src = e.target.result;
                        imagePreview.appendChild(img);
                    };
                    reader.readAsDataURL(file);
                }
            });
        }
        
        // Récupérer les images existantes d'une galerie d'un jeu
        if(document.querySelector('#galerie-preview')) {
            document.querySelectorAll('#galerie-preview .galerie-container img').forEach(img =>
            {
                this.current_gallery.push(img.dataset.id);
            });
        }  

        if(document.getElementById('galerie')) {
            document.getElementById('galerie').addEventListener('change', (event) =>
            {
                const galeriePreview = document.getElementById('galerie-preview');
                const files = event.target.files;
                Array.from(files).forEach(file =>
                {
                    const maxSizeInBytes = 4 * 1024 * 1024; // 2 Mo
                    if (file.size > maxSizeInBytes) {
                        event.preventDefault();
                        if(document.querySelector('html').getAttribute('lang') == "fr-FR") {
                            alert("Le fichier dépasse la taille maximale de 4 Mo. Veuillez sélectionner un fichier plus léger.");
                        } else {
                            alert("The file exceeds the maximum size of 4 MB. Please select a lighter file.");
                        }
                        return;
                    }

                    const reader = new FileReader();
                    reader.onload = (e) =>
                    {
                        const imgContainer = document.createElement('div');
                        imgContainer.classList.add('galerie-container');
                        const imgContent = document.createElement('div');
                        imgContent.classList.add('galerie-content');
                        imgContainer.appendChild(imgContent);

                        const img = document.createElement('img');
                        img.src = e.target.result;
                        img.dataset.id = file.name;
                        img.draggable = true;
                        imgContent.appendChild(img);
                        galeriePreview.appendChild(imgContainer);

                        const deleteImg = document.createElement('button');
                        deleteImg.classList.add('delete-galerie');
                        imgContainer.appendChild(deleteImg);

                        deleteImg.addEventListener('click', (event) => {this.deleteImage(event);});
                        
                        document.querySelector('#updated_gallery').value += ',' + file.name;
                    };
                    reader.readAsDataURL(file);
                });
            });
        }

        document.querySelectorAll('.delete-galerie').forEach(deleteButton =>
        {
            deleteButton.addEventListener('click', (event) => {this.deleteImage(event);});
        });


        if(document.querySelector("#jeu-form")) {
            
            this.initPlatforms();

            document.querySelector("#jeu-form").addEventListener('submit', function(event)
            {
                event.preventDefault();

                let form = event.target;
                gsap.to(".btn-loading", {duration:0.4, opacity: 1, display: 'block', ease:"power2.out"});
                gsap.to(".row_form .loading", {delay:0, duration:0.4, opacity: 1, display: 'block', ease:"power2.out"});
                
                let formData = new FormData(form);

                //let url = form.getAttribute('action');
                let url = mainScript.ajaxpost;

                fetch(url, {
                    method: 'POST',
                    body: formData
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                    }
                    return response.json();
                })
                .then(data => {

                    if (data.success) {

                        document.querySelector(".reponse p").innerHTML = data.data.message;
                        document.querySelector(".reponse").classList.add('success');
                        gsap.to(".btn-loading", {duration:0.4, opacity:0, display: 'none', ease:"power2.out"});
                        //gsap.to(".loading", {delay:0, duration:0.4, opacity:0, display: 'none', ease:"power2.out"});

                        let membre_id = data.data.membre_id;
                        let membre_token = data.data.membre_token;
                        let jeu_id = data.data.jeu_id;
                        let lien_user = '/formulaire-jeux/?membre_id=' + membre_id + '&jeu_id=' + jeu_id + '&token=' + membre_token;
                        if(document.querySelector('html').getAttribute('lang') == "en-US") {
                            lien_user = '/en/games-form/?membre_id=' + membre_id + '&jeu_id=' + jeu_id + '&token=' + membre_token;
                        }
                        
                        setTimeout(() => {
                            window.location.href = lien_user;
                        }, 1500);
                    }
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
            });
        }

        if(document.querySelector("#membre-form")) {
            
            document.querySelector("#membre-form").addEventListener('submit', function(event)
            {
                event.preventDefault();

                let form = event.target;
                gsap.to(".btn-loading", {duration:0.4, opacity: 1, display: 'block', ease:"power2.out"});
                gsap.to(".row_form .loading", {delay:0, duration:0.4, opacity: 1, display: 'block', ease:"power2.out"});

                let jeuxOrdre = "";
                document.querySelectorAll('.jeux-container .jeu').forEach(jeu =>
                {
                    jeuxOrdre += jeu.dataset.id + ',';
                });

                let formData = new FormData(form);
                formData.append('jeux_ordre', jeuxOrdre);

                //let url = form.getAttribute('action');
                let url = mainScript.ajaxpost;

                fetch(url, {
                    method: 'POST',
                    body: formData
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                    }
                    return response.json();
                })
                .then(data => {
                    
                    if (data.success) {

                        //Message : data.data.message

                        document.querySelector(".reponse p").innerHTML = data.data.message;
                        document.querySelector(".reponse").classList.add('success');
                        gsap.to(".btn-loading", {duration:0.4, opacity:0, display: 'none', ease:"power2.out"});
                        //gsap.to(".loading", {delay:0, duration:0.4, opacity:0, display: 'none', ease:"power2.out"});

                        let membre_id = data.data.membre_id;
                        let lien_user = data.data.lien_user;
                        
                        if(document.querySelector('html').getAttribute('lang') == "en-US") {
                            lien_user = '/en/membership-form/?membre_id=' + membre_id + '&token=' + data.data.token;
                        }
                        
                        setTimeout(() => {
                            window.location.href = lien_user;
                        }, 2000);
                    }
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
            });
        }
        

        document.querySelector("#newsletter-form").addEventListener('submit', async (event) =>
        {
            event.preventDefault();
            
            let form = event.target;
            form.querySelector(".form-response p").innerHTML = "";
            form.querySelector(".form-response").classList.remove('success');
            gsap.to(form.querySelector(".loading"), {delay:0, duration:0.4, opacity: 1, display: 'block', ease:"power2.out"});

            let formData = new FormData(form);
            let url = mainScript.ajaxurl;

            try {
                // Obtenir le token reCAPTCHA v3 avant la soumission
                let recaptchaToken = '';
                if (window.recaptchaSiteKey && typeof grecaptcha !== 'undefined') {
                    try {
                        recaptchaToken = await grecaptcha.execute(window.recaptchaSiteKey, {action: 'newsletter'});
                        form.querySelector('#recaptcha_token_newsletter').value = recaptchaToken;
                    } catch (recaptchaError) {
                        console.error('Erreur reCAPTCHA:', recaptchaError);
                    }
                }

                const response = await fetch(url, {
                  method: 'POST',
                  headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                  body: new URLSearchParams({
                    action: 'send_mailchimp',
                    first_name: formData.get('prenom'),
                    last_name: formData.get('nomFamille'),
                    email: formData.get('courriel'),
                    recaptcha_token: recaptchaToken,
                  }),
                });
            
                const result = await response.json();
            
                if(response.ok) {
                    //console.log('Inscription réussie!');
                    form.querySelector(".form-response p").innerHTML = result.data.message;
                    form.querySelector(".form-response").classList.add('success');
                    form.querySelector('input[name="nomFamille"]').value = "";
                    form.querySelector('input[name="prenom"]').value = "";
                    form.querySelector('input[type="email"]').value = "";
                    gsap.to(form.querySelector(".loading"), {delay:0, duration:0.4, opacity:0, display: 'none', ease:"power2.out"});
                } else {
                    console.log(`Erreur: ${result.data.message}`);
                    form.querySelector(".form-response p").innerHTML = result.data.message;
                    form.querySelector(".form-response").classList.add('success');
                }
            } catch (error) {
                console.log(`Erreur inattendue: ${error.message}`);
                form.querySelector(".form-response p").innerHTML = error.message;
                form.querySelector(".form-response").classList.add('success');
            }
        });


        if(document.querySelector("#form-devenir-membre")) {
            document.querySelector("#form-devenir-membre").addEventListener('submit', async (event) =>
            {
                event.preventDefault();
                
                let form = event.target;
                form.querySelector(".form-response p").innerHTML = "";
                form.querySelector(".form-response").classList.remove('success');
                gsap.to(form.querySelector(".loading"), {delay:0, duration:0.4, opacity: 1, display: 'block', ease:"power2.out"});

                let formData = new FormData(form);
                let url = mainScript.ajaxurl;

                try {
                    // Obtenir le token reCAPTCHA v3 avant la soumission
                    let recaptchaToken = '';
                    if (window.recaptchaSiteKey && typeof grecaptcha !== 'undefined') {
                        try {
                            recaptchaToken = await grecaptcha.execute(window.recaptchaSiteKey, {action: 'devenir_membre'});
                            form.querySelector('#recaptcha_token').value = recaptchaToken;
                        } catch (recaptchaError) {
                            console.error('Erreur reCAPTCHA:', recaptchaError);
                        }
                    }

                    const response = await fetch(url, {
                            method: 'POST',
                            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                            body: new URLSearchParams({
                            action: 'devenir_membre',
                            nom: formData.get('nom'),
                            courriel: formData.get('courriel'),
                            telephone: formData.get('telephone'),
                            province: formData.get('province'),
                            site: formData.get('site'),
                            recaptcha_token: recaptchaToken,
                        }),
                    });
                
                    const result = await response.json();
                
                    if(response.ok) {
                        form.querySelector(".form-response p").innerHTML = result.data.message;
                        form.querySelector(".form-response").classList.add('success');
                        form.querySelector('input[name="nom"]').value = "";
                        form.querySelector('input[type="email"]').value = "";
                        form.querySelector('input[type="tel"]').value = "";
                        form.querySelector('input[name="site"]').value = "";
                        form.querySelector('input[name="province"]').value = "";
                        gsap.to(form.querySelector(".loading"), {delay:0, duration:0.4, opacity:0, display: 'none', ease:"power2.out"});
                    } else {
                        console.log(`Erreur: ${result.data.message}`);
                        form.querySelector(".form-response p").innerHTML = result.data.message;
                        form.querySelector(".form-response").classList.add('success');
                    }
                } catch (error) {
                    console.log(`Erreur inattendue: ${error.message}`);
                    form.querySelector(".form-response p").innerHTML = error.message;
                    form.querySelector(".form-response").classList.add('success');
                }
                

                gsap.set(".form-devenir-membre", {transform: "translateX(0) translateY(-50%)"});
            });
        }


        if(document.querySelector("#form-update")) {
            document.querySelector("#form-update").addEventListener('submit', async (event) =>
            {
                event.preventDefault();
                
                let form = event.target;
                form.querySelector(".form-response p").innerHTML = "";
                form.querySelector(".form-response").classList.remove('success');
                gsap.to(form.querySelector(".loading"), {delay:0, duration:0.4, opacity: 1, display: 'block', ease:"power2.out"});

                let formData = new FormData(form);
                let url = mainScript.ajaxurl;

                try {
                    const response = await fetch(url, {
                            method: 'POST',
                            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                            body: new URLSearchParams({
                            action: 'nouveau_lien',
                            telephone: formData.get('telephone'),
                            courriel: formData.get('courriel'),
                            membre_id: formData.get('membre_id'),
                        }),
                    });
                
                    const result = await response.json();
                
                    if(response.ok) {
                        form.querySelector(".form-response p").innerHTML = result.data.message;
                        form.querySelector(".form-response").classList.add('success');
                        form.querySelector('input[type="email"]').value = "";
                        form.querySelector('input[type="tel"]').value = "";
                        gsap.to(form.querySelector(".loading"), {delay:0, duration:0.4, opacity:0, display: 'none', ease:"power2.out"});
                    } else {
                        console.log(`Erreur: ${result.data.message}`);
                        form.querySelector(".form-response p").innerHTML = result.data.message;
                        form.querySelector(".form-response").classList.add('success');
                    }
                } catch (error) {
                    console.log(`Erreur inattendue: ${error.message}`);
                    form.querySelector(".form-response p").innerHTML = error.message;
                    form.querySelector(".form-response").classList.add('success');
                }
                

                gsap.set(".form-update", {transform: "translateX(0) translateY(-50%)"});
            });
        }

	}

    initPlatforms()
    {
        document.querySelectorAll('.platform-item .platform-toggle').forEach((checkbox) =>
        {
            checkbox.addEventListener('change', () =>
            {
                const item = checkbox.closest('.platform-item');
                if (!item) {
                    return;
                }
                item.classList.toggle('is-on', checkbox.checked);
                if (checkbox.checked) {
                    const url = item.querySelector('.platform-url input');
                    if (url) {
                        url.focus();
                    }
                }
            });
        });
    }

    deleteImage(event)
    {
        event.preventDefault();
        const imgContainer = event.target.parentNode;
        const idImg = imgContainer.querySelector('img').dataset.id;

        if(idImg !== "") {

            const index = this.current_gallery.indexOf(idImg);
            if (index > -1) {
                this.current_gallery.splice(index, 1);
            }

            document.querySelector('#updated_gallery').value = this.current_gallery.join(',');
        }

        imgContainer.remove();
        document.querySelector('#jeu-form label[for=galerie] > span').innerHTML = "";
    }
}

export default Formulaire;